(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muwo-countdown-bar"]) return;
  try {
    
  class MuwoCountdownBar extends HTMLElement {
    connectedCallback() {
      this.mode = this.dataset.mode || 'daily';
      this.target = Number(this.dataset.target) * 1000;
      this.fields = {
        days: this.querySelector('[data-muwo-cd="days"]'),
        hours: this.querySelector('[data-muwo-cd="hours"]'),
        minutes: this.querySelector('[data-muwo-cd="minutes"]'),
        seconds: this.querySelector('[data-muwo-cd="seconds"]'),
      };

      if (!this.target) {
        this.hidden = true;
        return;
      }

      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    tick() {
      let remaining = this.target - Date.now();

      if (remaining <= 0) {
        if (this.mode === 'daily') {
          // Self-heal a cached page: roll forward to the next daily cutoff.
          const day = 86400000;
          const missed = Math.ceil(-remaining / day) || 1;
          this.target += missed * day;
          remaining = this.target - Date.now();
        } else {
          this.hidden = true;
          if (this.interval) clearInterval(this.interval);
          return;
        }
      }

      const total = Math.floor(remaining / 1000);
      const days = Math.floor(total / 86400);
      const hours = Math.floor((total % 86400) / 3600);
      const minutes = Math.floor((total % 3600) / 60);
      const seconds = total % 60;

      this.set('days', days);
      this.set('hours', hours);
      this.set('minutes', minutes);
      this.set('seconds', seconds);
    }

    set(key, value) {
      const el = this.fields[key];
      if (!el) return;
      const next = String(value).padStart(2, '0');
      if (el.textContent !== next) el.textContent = next;
    }
  }

  if (!customElements.get('muwo-countdown-bar')) {
    customElements.define('muwo-countdown-bar', MuwoCountdownBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muwo-glass-menu"] && !Shopify.designMode) return;
  try {
    
  class MuwoGlassMenu extends HTMLElement {
    connectedCallback() {
      // Portal to <body>: the header group's sticky ancestors carry transforms,
      // which re-anchor position:fixed to the header (the menu then opens at
      // tap height instead of the viewport top). From <body>, fixed = viewport.
      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
        return; // re-enters connectedCallback from the new parent
      }
      if (this.wired) return;
      this.wired = true;

      this.panel = this.querySelector('[data-muwo-gm-panel]');
      this.tabs = Array.from(this.querySelectorAll('[data-muwo-gm-tab]'));
      this.panes = Array.from(this.querySelectorAll('[data-muwo-gm-pane]'));
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

      // Intercept the header hamburger so this menu opens instead of Horizon's
      // drawer (which stays as the no-JS fallback). Tapping it again closes —
      // a true toggle, so repeated taps can't desync any state.
      this.onDocClick = (e) => {
        const burger = e.target.closest('.header__icon--summary');
        if (burger) {
          e.preventDefault();
          e.stopPropagation();
          this.forceDrawerClosed();
          if (this.hidden) this.open(burger);
          else this.close();
          return;
        }
        if (this.hidden) return;
        if (e.target.closest('[data-muwo-gm-close]')) {
          this.close();
          return;
        }
        // Links inside the menu.
        const link = e.target.closest('.muwo-gm__stack a[href]');
        if (link) {
          this.skipScrollRestore = true;
          const url = new URL(link.href, window.location.href);
          const samePage = url.pathname === window.location.pathname;
          const target = url.hash ? document.querySelector(url.hash) : null;

          // Same-page anchor: drive the scroll ourselves. A plain #hash does
          // nothing when the hash is already set (tapping the same row twice),
          // and it also races the scroll-lock release — so it only worked from
          // certain positions. This lands from anywhere on the page.
          if (samePage && target) {
            e.preventDefault();
            // close() releases the scroll lock synchronously, so scroll right
            // after it — no requestAnimationFrame: rAF never fires in a
            // backgrounded tab and the jump would silently never happen.
            this.close();
            this.scrollToTarget(target);
            history.replaceState(null, '', url.hash);
            return;
          }

          // Different page: let the browser navigate (it resolves the hash on load).
          this.close();
          return;
        }
        // Tap outside the panel: don't kill the menu — retract to bar-only
        // (Seed). The tab bar stays as the header, the page scrolls free.
        if (e.target.closest('[data-muwo-gm-collapse]')) this.collapse();
      };
      document.addEventListener('click', this.onDocClick, true);

      this.onKey = (e) => {
        if (e.key === 'Escape' && !this.hidden) this.close();
      };
      document.addEventListener('keydown', this.onKey);

      // Floating-header state (Seed): past a small threshold the white slab
      // dissolves and only logo + buttons stay, as glass pills. Horizon may
      // scroll .page-wrapper instead of window, and those events don't bubble
      // — capture:true catches both.
      this.onScroll = () => {
        // While the menu locks the body, window.scrollY reads 0 — freezing the
        // float state prevents the white bar from flashing back behind the menu.
        if (this.lockMode) return;
        const wrapper = document.querySelector('.page-wrapper');
        const y = Math.max(window.scrollY || 0, wrapper ? wrapper.scrollTop : 0);
        document.documentElement.classList.toggle('muwo-hdr-float', y > 24);
        // Bar-only mode stands in for the real header, which is opacity:0 but
        // still in-flow — its padding-top (and so the hamburger's real
        // position) keeps changing as muwo-hdr-float toggles mid-scroll. Track
        // it live, or the pill freezes wherever it was at collapse() and jumps
        // out of sync with where the (hidden) header actually is.
        if (this.classList.contains('is-bar')) this.positionBar();
      };
      window.addEventListener('scroll', this.onScroll, { capture: true, passive: true });
      this.onScroll();

      // Scroll intent OUTSIDE the panel (swipe on the backdrop / mouse wheel)
      // retracts to bar-only — Seed's behavior — instead of a dead gesture
      // against the scroll lock.
      this.onGesture = (e) => {
        if (this.hidden || this.classList.contains('is-bar')) return;
        // En touch, el colapso llega con el dedo TODAVIA en pantalla: hay que
        // diferir el unlock hasta que se levante (ver collapse()).
        if (!e.target.closest('.muwo-gm__stack')) this.collapse(e.type === 'touchmove');
      };
      window.addEventListener('wheel', this.onGesture, { capture: true, passive: true });
      window.addEventListener('touchmove', this.onGesture, { capture: true, passive: true });

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          // From bar-only mode a tab tap re-expands the panel on that tab.
          if (this.classList.contains('is-bar')) this.expand();
          this.select(tab.dataset.muwoGmTab);
        });
      });

      // Sign in / Create account are plain links to Shopify's hosted account pages now — nothing
      // to wire up here.
    }

    disconnectedCallback() {
      if (!this.wired) return;
      document.removeEventListener('click', this.onDocClick, true);
      document.removeEventListener('keydown', this.onKey);
      window.removeEventListener('scroll', this.onScroll, true);
      window.removeEventListener('wheel', this.onGesture, true);
      window.removeEventListener('touchmove', this.onGesture, true);
      this.wired = false;
    }

    // The page does NOT scroll on window: html/body are overflow:hidden and
    // .page-wrapper is the scroller. Find whichever ancestor actually scrolls.
    scrollerFor(el) {
      let node = el.parentElement;
      while (node && node !== document.body) {
        const cs = getComputedStyle(node);
        if (/auto|scroll/.test(cs.overflowY) && node.scrollHeight > node.clientHeight + 4) return node;
        node = node.parentElement;
      }
      return null; // window
    }

    // Scroll to a section. All measured in the browser on this theme:
    //  · scrollTop assignment and scrollIntoView do NOTHING here — .page-wrapper
    //    carries scroll-behavior:smooth and its native smooth scrolls get
    //    cancelled, so the scroll silently never happens (this was the bug).
    //  · Only scrollTo({behavior:'instant'}) lands.
    //  · Writing scroll positions every frame (a JS tween) FREEZES the renderer:
    //    too many scroll listeners + backdrop-filter repaints on this page.
    // So: one instant jump. Reliable, and it reads fine because the menu is
    // closing over it.
    scrollToTarget(target) {
      const scroller = this.scrollerFor(target);
      const OFFSET = 110; // clears the floating header
      const from = scroller ? scroller.scrollTop : window.scrollY || 0;
      const base = scroller ? scroller.getBoundingClientRect().top : 0;
      const max = scroller
        ? scroller.scrollHeight - scroller.clientHeight
        : document.documentElement.scrollHeight - window.innerHeight;
      const to = Math.max(0, Math.min(from + target.getBoundingClientRect().top - base - OFFSET, Math.max(0, max)));

      if (scroller) scroller.scrollTo({ top: to, behavior: 'instant' });
      else window.scrollTo({ top: to, behavior: 'instant' });
    }

    // Horizon's drawer JS may still toggle its <details> behind our overlay
    // (that's what flashed the X in the header). Keep it shut.
    forceDrawerClosed() {
      const details = document.getElementById('Details-menu-drawer-container');
      if (details) details.removeAttribute('open');
    }

    // Anchor the pill bar at the (real, hidden) hamburger's height, centered
    // on its row. Horizon renders several .header__icon--summary variants
    // (some hidden, rect = 0), so trust the tapped element first and
    // otherwise pick the VISIBLE one — never just the first match. Re-run any
    // time the header's own layout could have shifted (open, collapse, and
    // every scroll tick while bar-only), so the pill tracks it instead of
    // freezing at whatever position it had on the last call.
    positionBar(tappedBurger) {
      let burger = tappedBurger;
      if (!burger || !burger.getClientRects().length) {
        burger = Array.from(document.querySelectorAll('.header__icon--summary')).find(
          (el) => el.getClientRects().length > 0
        );
      }
      let top = 10;
      if (burger) {
        const rect = burger.getBoundingClientRect();
        const barHeight = 52; // pill bar approx height
        if (rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight) {
          top = Math.max(10, rect.top + rect.height / 2 - barHeight / 2);
        }
      }
      this.style.setProperty('--muwo-gm-top', top + 'px');
    }

    open(tappedBurger) {
      this.positionBar(tappedBurger);

      this.hidden = false;
      document.documentElement.classList.add('muwo-gm-active');
      // double rAF so the transition runs from the hidden state
      requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-open')));
      this.lockScroll(true);
      const active = this.tabs.find((t) => t.getAttribute('aria-selected') === 'true');
      if (active) active.focus({ preventScroll: true });
    }

    // Retract to bar-only: panel + backdrop fold away, scroll unlocks, the tab
    // bar glides up under the Dynamic Island and acts as the header.
    collapse(deferUnlock) {
      if (this.hidden || this.classList.contains('is-bar')) return;
      this.classList.add('is-bar');
      // Soltar el body-lock con el dedo aún apoyado deja que Safari siga el
      // swipe anclado al documento colapsado (una pantalla de alto) y PISE la
      // posición restaurada — por eso "subía hasta arriba de todo". Con touch,
      // el unlock espera a que el dedo se levante.
      // (Probado soltarlo antes en el modo 'wrapper' para que el scroll no se
      // sintiera trabado — Mati, 2026-07-27: no lo resolvió, y complicaba el
      // código sin mejorar nada. Vuelto al defer simple de siempre.)
      if (deferUnlock) {
        const release = () => {
          window.removeEventListener('touchend', release, true);
          window.removeEventListener('touchcancel', release, true);
          this.lockScroll(false);
          // Scroll only actually unfreezes here — re-measure now that the
          // (hidden) header sits at its real, final position.
          this.positionBar();
        };
        window.addEventListener('touchend', release, { capture: true });
        window.addEventListener('touchcancel', release, { capture: true });
      } else {
        this.lockScroll(false);
      }
      this.forceDrawerClosed();
      // Same spot the (hidden) header is really in right now, not a hardcoded
      // "float" position — this used to jump the pill to a fixed 8px even
      // when collapsing from the top of the page, where the real header sits
      // lower (Mati, 2026-07-27: "se buguea como que se mueve de lugar").
      this.positionBar();
    }

    expand() {
      this.classList.remove('is-bar');
      this.lockScroll(true);
    }

    close() {
      this.classList.remove('is-open');
      this.classList.remove('is-bar');
      document.documentElement.classList.remove('muwo-gm-active');
      this.lockScroll(false);
      this.forceDrawerClosed();
      const done = () => {
        this.hidden = true;
      };
      if (this.reduced.matches) done();
      else setTimeout(done, 230);
    }

    lockScroll(on) {
      // overflow:hidden on <html> clamps the window scroll to 0 → the page
      // jumped to the top behind the menu. Instead: if window scrolls, use the
      // iOS-style body-fixed lock (preserves position exactly); if Horizon's
      // .page-wrapper scrolls, overflow:hidden there is safe (inner scrollers
      // keep their scrollTop).
      const wrapper = document.querySelector('.page-wrapper');
      const windowScrolls = (window.scrollY || 0) > 0 || !wrapper || wrapper.scrollHeight <= wrapper.clientHeight;

      if (on) {
        // Reentrada (ej: expandir desde la barra antes de que el touchend
        // difiera el unlock): re-guardar aquí pisaría savedY con el 0 del
        // documento todavía colapsado.
        if (this.lockMode) return;
        if (windowScrolls) {
          this.savedY = window.scrollY || 0;
          this.lockMode = 'body';
          document.body.style.position = 'fixed';
          document.body.style.top = -this.savedY + 'px';
          document.body.style.left = '0';
          document.body.style.right = '0';
          document.body.style.width = '100%';
        } else {
          this.lockMode = 'wrapper';
          wrapper.style.overflow = 'hidden';
        }
      } else {
        if (this.lockMode === 'body') {
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.left = '';
          document.body.style.right = '';
          document.body.style.width = '';
          // Restore INSTANTLY: the theme's scroll-behavior:smooth would
          // otherwise animate from the top back down — the weird
          // "returning from the start" effect.
          if (this.skipScrollRestore) {
            // Navigating to an anchor — let the browser land where it wants.
            this.skipScrollRestore = false;
          } else {
            const html = document.documentElement;
            const prevBehavior = html.style.scrollBehavior;
            html.style.scrollBehavior = 'auto';
            window.scrollTo({ top: this.savedY || 0, left: 0, behavior: 'instant' });
            html.style.scrollBehavior = prevBehavior;
          }
        } else if (this.lockMode === 'wrapper' && wrapper) {
          wrapper.style.overflow = '';
        }
        this.lockMode = null;
      }
    }

    select(name) {
      const current = this.panes.find((p) => !p.hidden);
      const next = this.panes.find((p) => p.dataset.muwoGmPane === name);
      if (!next || next === current) return;

      this.tabs.forEach((t) => t.setAttribute('aria-selected', t.dataset.muwoGmTab === name ? 'true' : 'false'));

      const swap = () => {
        // FLIP-style height morph: measure before/after, animate the difference.
        const from = this.panel.offsetHeight;
        if (current) current.hidden = true;
        next.hidden = false;
        const to = this.panel.offsetHeight;

        if (!this.reduced.matches && from !== to && this.panel.animate) {
          this.panel.animate(
            [{ height: from + 'px' }, { height: to + 'px' }],
            { duration: 260, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' }
          );
        }

        if (!this.reduced.matches) {
          next.classList.add('is-entering');
          next.addEventListener('animationend', () => next.classList.remove('is-entering'), { once: true });
        }
      };

      // Dos fases (Mati): el pane actual se DESVANECE primero, recién ahí el
      // nuevo se despliega hacia abajo. Si se toca otro tab en plena
      // transición, cancel() descarta el swap viejo (onfinish no dispara en
      // cancel) y la nueva fase 1 arranca desde el pane aún visible.
      if (this._paneFade) {
        this._paneFade.cancel();
        this._paneFade = null;
      }
      if (!this.reduced.matches && current && current.animate) {
        const fade = current.animate(
          [{ opacity: 1 }, { opacity: 0 }],
          { duration: 130, easing: 'ease-out' }
        );
        this._paneFade = fade;
        fade.onfinish = () => {
          if (this._paneFade === fade) this._paneFade = null;
          swap();
        };
      } else {
        swap();
      }
    }
  }

  if (!customElements.get('muwo-glass-menu')) {
    customElements.define('muwo-glass-menu', MuwoGlassMenu);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muwo-reviews"] && !Shopify.designMode) return;
  try {
    
  class MuwoReviews extends HTMLElement {
    connectedCallback() {
      let reviews = window.MUWO_REVIEWS;
      if (!Array.isArray(reviews)) reviews = [];
      this.reviews = reviews;

      this.pageSize = parseInt(this.dataset.pageSize, 10) || 10;
      this.showPlaceholders = this.dataset.showPlaceholders === 'true';
      this.assetBase = this.dataset.assetBase || '';

      this.state = { search: '', topics: new Set(), rating: null, sort: 'rating_high', page: 1 };

      this.els = {
        list: this.querySelector('[data-rv-list]'),
        nav: this.querySelector('[data-rv-nav]'),
        count: this.querySelector('[data-rv-count]'),
        empty: this.querySelector('[data-rv-empty]'),
        topics: this.querySelector('[data-rv-topics]'),
        breakdown: this.querySelector('[data-rv-breakdown]'),
        avg: this.querySelector('[data-rv-avg]'),
        avgStars: this.querySelector('[data-rv-avg-stars]'),
        total: this.querySelector('[data-rv-total]'),
        search: this.querySelector('[data-rv-search]'),
        sort: this.querySelector('[data-rv-sort]'),
      };

      this.topicLabels = {
        inflammation: 'Inflammation',
        joints: 'Joints',
        digestion: 'Digestion',
        bloating: 'Bloating',
        energy: 'Energy',
        metabolism: 'Metabolism',
        immunity: 'Immunity',
        mobility: 'Mobility',
        skin: 'Skin',
        mood: 'Mood',
      };

      this.votes = this.loadVotes();

      this.renderSummary();
      this.renderTopics();
      this.bind();
      this.update();
    }

    /* ----- helpers ----- */
    starSVG(filled) {
      const cls = filled ? 'muwo-rv__star' : 'muwo-rv__star muwo-rv__star--empty';
      return (
        '<svg class="' +
        cls +
        '" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">' +
        '<path d="M12 1.8l3.09 6.26 6.91 1-5 4.87 1.18 6.87L12 17.56l-6.18 3.25L7 13.94l-5-4.87 6.91-1L12 1.8z"/></svg>'
      );
    }

    stars(n) {
      let out = '';
      for (let i = 1; i <= 5; i++) out += this.starSVG(i <= Math.round(n));
      return out;
    }

    esc(str) {
      const d = document.createElement('div');
      d.textContent = str == null ? '' : String(str);
      return d.innerHTML;
    }

    fmtDate(iso) {
      if (!iso) return '';
      const parts = String(iso).split('-');
      if (parts.length !== 3) return this.esc(iso);
      const [y, m, d] = parts;
      return m + '/' + d + '/' + y.slice(2);
    }

    photoUrl(photo) {
      if (!photo) return '';
      if (/^https?:\/\//.test(photo)) return photo;
      return this.assetBase + photo;
    }

    loadVotes() {
      try {
        return JSON.parse(localStorage.getItem('muwo-rv-votes') || '{}');
      } catch (e) {
        return {};
      }
    }

    saveVotes() {
      try {
        localStorage.setItem('muwo-rv-votes', JSON.stringify(this.votes));
      } catch (e) {}
    }

    /* ----- summary ----- */
    renderSummary() {
      const n = this.reviews.length;
      const sum = this.reviews.reduce((a, r) => a + (Number(r.rating) || 0), 0);
      const avg = n ? sum / n : 0;
      this.els.avg.textContent = avg.toFixed(1);
      this.els.avgStars.innerHTML = this.stars(avg);
      this.els.total.textContent = 'Based on ' + n.toLocaleString() + ' review' + (n === 1 ? '' : 's');

      const counts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
      this.reviews.forEach((r) => {
        const k = Math.round(Number(r.rating) || 0);
        if (counts[k] != null) counts[k]++;
      });
      const max = Math.max(1, ...Object.values(counts));
      let html = '';
      for (let s = 5; s >= 1; s--) {
        const pct = Math.round((counts[s] / max) * 100);
        html +=
          '<button type="button" class="muwo-rv__bar-row" data-rating="' +
          s +
          '">' +
          '<span class="muwo-rv__bar-label">' +
          s +
          '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 1.8l3.09 6.26 6.91 1-5 4.87 1.18 6.87L12 17.56l-6.18 3.25L7 13.94l-5-4.87 6.91-1L12 1.8z"/></svg>' +
          '</span>' +
          '<span class="muwo-rv__bar-track"><span class="muwo-rv__bar-fill" style="width:' +
          pct +
          '%"></span></span>' +
          '<span class="muwo-rv__bar-count">' +
          counts[s].toLocaleString() +
          '</span></button>';
      }
      this.els.breakdown.innerHTML = html;
    }

    renderTopics() {
      const present = new Set();
      this.reviews.forEach((r) => (r.topics || []).forEach((t) => present.add(t)));
      const order = Object.keys(this.topicLabels).filter((t) => present.has(t));
      // any topics in data not in our label map, appended
      present.forEach((t) => {
        if (!this.topicLabels[t]) {
          this.topicLabels[t] = t.charAt(0).toUpperCase() + t.slice(1);
          order.push(t);
        }
      });

      const LIMIT = 8;
      let html = '';
      order.forEach((t, i) => {
        html +=
          '<button type="button" class="muwo-rv__chip" data-topic="' +
          t +
          '"' +
          (i >= LIMIT ? ' hidden data-extra' : '') +
          '>' +
          this.esc(this.topicLabels[t]) +
          '</button>';
      });
      if (order.length > LIMIT) {
        html += '<button type="button" class="muwo-rv__chip muwo-rv__chip--more" data-rv-morechips>Show more</button>';
      }
      this.els.topics.innerHTML = html;
    }

    /* ----- events ----- */
    bind() {
      let t;
      this.els.search.addEventListener('input', (e) => {
        clearTimeout(t);
        t = setTimeout(() => {
          this.state.search = e.target.value.trim().toLowerCase();
          this.state.page = 1;
          this.update();
        }, 180);
      });

      this.els.sort.addEventListener('change', (e) => {
        this.state.sort = e.target.value;
        this.state.page = 1;
        this.update();
      });

      this.els.topics.addEventListener('click', (e) => {
        const more = e.target.closest('[data-rv-morechips]');
        if (more) {
          this.querySelectorAll('[data-extra]').forEach((c) => c.removeAttribute('hidden'));
          more.remove();
          return;
        }
        const chip = e.target.closest('[data-topic]');
        if (!chip) return;
        const topic = chip.dataset.topic;
        if (this.state.topics.has(topic)) this.state.topics.delete(topic);
        else this.state.topics.add(topic);
        chip.classList.toggle('is-active');
        this.state.page = 1;
        this.update();
      });

      this.els.breakdown.addEventListener('click', (e) => {
        const row = e.target.closest('[data-rating]');
        if (!row) return;
        const r = parseInt(row.dataset.rating, 10);
        this.state.rating = this.state.rating === r ? null : r;
        this.els.breakdown.querySelectorAll('.muwo-rv__bar-row').forEach((x) => x.classList.remove('is-active'));
        if (this.state.rating) row.classList.add('is-active');
        this.state.page = 1;
        this.update();
      });

      this.addEventListener('click', (e) => {
        const clear = e.target.closest('[data-rv-clear]');
        if (clear) {
          this.clearFilters();
          return;
        }
        const rm = e.target.closest('[data-rv-readmore]');
        if (rm) {
          const body = rm.previousElementSibling;
          body.classList.remove('is-clamped');
          rm.remove();
          return;
        }
        const vote = e.target.closest('[data-vote]');
        if (vote) {
          this.handleVote(vote);
          return;
        }
        const page = e.target.closest('[data-page]');
        if (page && !page.disabled) {
          this.state.page = parseInt(page.dataset.page, 10);
          this.update();
          this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    handleVote(btn) {
      const id = btn.dataset.vote;
      const dir = btn.dataset.dir;
      const key = id + ':' + dir;
      if (this.votes[key]) return; // one vote per direction per browser
      this.votes[key] = true;
      this.saveVotes();
      const countEl = btn.querySelector('[data-vote-count]');
      countEl.textContent = (parseInt(countEl.textContent, 10) || 0) + 1;
      btn.classList.add('is-voted');
    }

    clearFilters() {
      this.state.search = '';
      this.state.topics.clear();
      this.state.rating = null;
      this.state.page = 1;
      this.els.search.value = '';
      this.els.topics.querySelectorAll('.is-active').forEach((c) => c.classList.remove('is-active'));
      this.els.breakdown.querySelectorAll('.is-active').forEach((c) => c.classList.remove('is-active'));
      this.update();
    }

    /* ----- filter + sort ----- */
    filtered() {
      const { search, topics, rating } = this.state;
      let out = this.reviews.filter((r) => {
        if (rating && Math.round(Number(r.rating)) !== rating) return false;
        if (topics.size) {
          const rt = r.topics || [];
          let hit = false;
          topics.forEach((t) => {
            if (rt.indexOf(t) !== -1) hit = true;
          });
          if (!hit) return false;
        }
        if (search) {
          const hay = ((r.body || '') + ' ' + (r.title || '') + ' ' + (r.name || '')).toLowerCase();
          if (hay.indexOf(search) === -1) return false;
        }
        return true;
      });

      const s = this.state.sort;
      const cmp = (a, b) => {
        if (s === 'rating_high') return (b.rating - a.rating) || (b.date > a.date ? 1 : -1);
        if (s === 'rating_low') return (a.rating - b.rating) || (b.date > a.date ? 1 : -1);
        if (s === 'helpful') return (b.helpful_up || 0) - (a.helpful_up || 0);
        return b.date > a.date ? 1 : b.date < a.date ? -1 : 0; // recent
      };
      // Pinned reviews first (in pin order), then any review with a real photo floats to the first
      // pages (strongest social proof), then the chosen sort.
      const pin = (r) => (typeof r.pin === 'number' ? r.pin : Infinity);
      out.sort((a, b) => pin(a) - pin(b) || (b.photo ? 1 : 0) - (a.photo ? 1 : 0) || cmp(a, b));
      return out;
    }

    /* ----- render ----- */
    update() {
      const results = this.filtered();
      const total = results.length;
      const pages = Math.max(1, Math.ceil(total / this.pageSize));
      if (this.state.page > pages) this.state.page = pages;
      const start = (this.state.page - 1) * this.pageSize;
      const pageItems = results.slice(start, start + this.pageSize);

      const hasFilters = this.state.search || this.state.topics.size || this.state.rating;
      this.els.count.textContent = 'We found ' + total.toLocaleString() + ' matching review' + (total === 1 ? '' : 's');
      this.querySelectorAll('[data-rv-clear]').forEach((b) => (b.hidden = !hasFilters));

      this.els.empty.hidden = total !== 0;
      this.els.list.hidden = total === 0;

      this.els.list.innerHTML = pageItems.map((r) => this.card(r)).join('');
      this.clampBodies();
      this.renderNav(pages);
    }

    card(r) {
      const verified = r.verified
        ? '<span class="muwo-rv__verified"><svg viewBox="0 0 20 20" fill="none" aria-hidden="true">' +
          '<circle cx="10" cy="10" r="9" fill="currentColor"/>' +
          '<path d="M6 10.2l2.6 2.6L14 7.4" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          'Verified Buyer</span>'
        : '';

      const avatar = r.avatar
        ? '<img class="muwo-rv__avatar" src="' + this.esc(this.photoUrl(r.avatar)) + '" alt="" loading="lazy" width="40" height="40">'
        : '';

      let photo = '';
      if (r.photo) {
        photo =
          '<div class="muwo-rv__photo"><img src="' +
          this.esc(this.photoUrl(r.photo)) +
          '" alt="Customer photo from ' +
          this.esc(r.name) +
          '" loading="lazy"></div>';
      } else if (r.has_photo && this.showPlaceholders) {
        photo =
          '<div class="muwo-rv__photo muwo-rv__photo--placeholder"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg></div>';
      }

      const title = r.title ? '<p class="muwo-rv__title">' + this.esc(r.title) + '</p>' : '';

      const up = (r.helpful_up || 0) + (this.votes[r.id + ':up'] ? 1 : 0);
      const down = (r.helpful_down || 0) + (this.votes[r.id + ':down'] ? 1 : 0);
      const helpful =
        '<div class="muwo-rv__helpful"><span>Was this review helpful?</span>' +
        '<button type="button" class="muwo-rv__vote' +
        (this.votes[r.id + ':up'] ? ' is-voted' : '') +
        '" data-vote="' +
        r.id +
        '" data-dir="up" aria-label="Helpful">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M7 10v10M7 10l4-7a2 2 0 0 1 3 1.7V9h5a2 2 0 0 1 2 2.3l-1.2 7A2 2 0 0 1 20.8 20H7"/></svg>' +
        '<span data-vote-count>' +
        up +
        '</span></button>' +
        '<button type="button" class="muwo-rv__vote' +
        (this.votes[r.id + ':down'] ? ' is-voted' : '') +
        '" data-vote="' +
        r.id +
        '" data-dir="down" aria-label="Not helpful">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M17 14V4M17 14l-4 7a2 2 0 0 1-3-1.7V15H5a2 2 0 0 1-2-2.3l1.2-7A2 2 0 0 1 6.2 4H17"/></svg>' +
        '<span data-vote-count>' +
        down +
        '</span></button></div>';

      let reply = '';
      if (r.reply && r.reply.body) {
        reply =
          '<div class="muwo-rv__reply"><span class="muwo-rv__reply-author">' +
          this.esc(r.reply.author || 'MUWO Team') +
          '</span><p class="muwo-rv__reply-body">' +
          this.esc(r.reply.body) +
          '</p>' +
          (r.reply.date ? '<span class="muwo-rv__reply-date">' + this.fmtDate(r.reply.date) + '</span>' : '') +
          '</div>';
      }

      return (
        '<article class="muwo-rv__card">' +
        '<div class="muwo-rv__meta">' +
        avatar +
        '<div class="muwo-rv__name-row"><span class="muwo-rv__name">' +
        this.esc(r.name) +
        '</span>' +
        (r.country ? '<span class="muwo-rv__country">' + this.esc(r.country) + '</span>' : '') +
        '</div>' +
        verified +
        '<span class="muwo-rv__date">' +
        this.fmtDate(r.date) +
        '</span>' +
        '</div>' +
        '<div class="muwo-rv__content">' +
        '<span class="muwo-rv__stars muwo-rv__card-stars" aria-label="' +
        r.rating +
        ' out of 5 stars">' +
        this.stars(r.rating) +
        '</span>' +
        title +
        '<p class="muwo-rv__body is-clamped">' +
        this.esc(r.body) +
        '</p>' +
        '<button type="button" class="muwo-rv__readmore" data-rv-readmore hidden>Read more</button>' +
        photo +
        helpful +
        reply +
        '</div>' +
        '</article>'
      );
    }

    clampBodies() {
      this.els.list.querySelectorAll('.muwo-rv__body').forEach((body) => {
        const btn = body.nextElementSibling;
        if (!btn || !btn.matches('[data-rv-readmore]')) return;
        if (body.scrollHeight - body.clientHeight > 4) {
          btn.hidden = false;
        } else {
          body.classList.remove('is-clamped');
          btn.remove();
        }
      });
    }

    renderNav(pages) {
      if (pages <= 1) {
        this.els.nav.innerHTML = '';
        return;
      }
      const cur = this.state.page;
      const btn = (label, page, opts) => {
        opts = opts || {};
        if (opts.ellipsis) return '<span class="muwo-rv__page-ellipsis">…</span>';
        return (
          '<button type="button" class="muwo-rv__page' +
          (opts.active ? ' is-active' : '') +
          '" data-page="' +
          page +
          '"' +
          (opts.disabled ? ' disabled' : '') +
          (opts.active ? ' aria-current="page"' : '') +
          '>' +
          label +
          '</button>'
        );
      };

      const nums = [];
      const push = (p) => nums.push(p);
      push(1);
      const from = Math.max(2, cur - 1);
      const to = Math.min(pages - 1, cur + 1);
      if (from > 2) nums.push('...');
      for (let p = from; p <= to; p++) push(p);
      if (to < pages - 1) nums.push('...');
      if (pages > 1) push(pages);

      let html = btn('‹', cur - 1, { disabled: cur === 1 });
      nums.forEach((p) => {
        if (p === '...') html += btn('', 0, { ellipsis: true });
        else html += btn(String(p), p, { active: p === cur });
      });
      html += btn('›', cur + 1, { disabled: cur === pages });
      this.els.nav.innerHTML = html;
    }
  }

  if (!customElements.get('muwo-reviews')) {
    customElements.define('muwo-reviews', MuwoReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-reviews"] && !Shopify.designMode) return;
  try {
    
  class VideoReviewsComponent extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.video-reviews__card'));
      if (!this.cards.length) return;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reducedMotion) {
        this.cards.forEach((card) => {
          const video = card.querySelector('.video-reviews__video');
          if (video) video.setAttribute('controls', '');
          card.removeAttribute('role');
          card.removeAttribute('tabindex');
        });
        return;
      }

      this.cards.forEach((card) => {
        const video = card.querySelector('.video-reviews__video');
        if (!video) return;
        card.addEventListener('click', () => this.toggleCard(card));
        card.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.toggleCard(card);
          }
        });
      });

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            const card = video.closest('.video-reviews__card');
            if (entry.isIntersecting) {
              if (!card.classList.contains('is-active')) {
                video.play().catch(() => {});
              }
            } else {
              if (card.classList.contains('is-active')) {
                this.deactivateCard(card);
              }
              video.pause();
            }
          });
        },
        { threshold: 0.4 }
      );

      this.cards.forEach((card) => {
        const video = card.querySelector('.video-reviews__video');
        if (video) this.observer.observe(video);
      });
    }

    toggleCard(card) {
      const video = card.querySelector('.video-reviews__video');
      if (!video) return;

      if (card.classList.contains('is-active')) {
        if (video.paused) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
        return;
      }

      this.cards.forEach((other) => {
        if (other !== card) this.deactivateCard(other);
      });

      card.classList.add('is-active');
      card.setAttribute('aria-pressed', 'true');
      video.currentTime = 0;
      video.muted = false;
      video.play().catch(() => {});
      card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    deactivateCard(card) {
      const video = card.querySelector('.video-reviews__video');
      if (!video) return;
      card.classList.remove('is-active');
      card.setAttribute('aria-pressed', 'false');
      video.muted = true;
      video.play().catch(() => {});
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get('video-reviews-component')) {
    customElements.define('video-reviews-component', VideoReviewsComponent);
  }

  } catch(e) { console.error(e); }
})();
})();
